module.exports = __webpack_public_path__ + "static/media/cadillac_logo.ae62bcbb.png";